import { browser } from '$app/environment';
import { get, writable } from 'svelte/store';
import { sessionOrLocaleStorage } from './localeOrSessionStorage';

function getNumberFromSessionStorage(storageKey: string): number | null {
	const storedValue = sessionStorage.getItem(storageKey);
	if (storedValue === null) {
		return null;
	}
	const storedValueAsNumber = Number(storedValue);
	if (Number.isNaN(storedValueAsNumber)) {
		sessionStorage.removeItem(storageKey);
		return null;
	}
	return storedValueAsNumber;
}

export function createSessionStorageNumberStore(storageKey: string, defaultValue: number) {
	const initialSessionStorageValue = getNumberFromSessionStorage(storageKey);
	const valueStore = writable<number>(initialSessionStorageValue ?? defaultValue);

	function set(value: number) {
		sessionStorage.setItem(storageKey, JSON.stringify(value));
		valueStore.set(value);
	}

	function update(callback: (value: number) => number) {
		const value = callback(get(valueStore));
		set(value);
	}

	return {
		subscribe: valueStore.subscribe,
		increment() {
			update(nb => nb + 1);
		},
	};
}

export function decrementStorageNumberOnSE(storageKey: string, maxNbOpenPerSession: number) {
	const initialSessionStorageValue = getNumberFromSessionStorage(storageKey);
	if (initialSessionStorageValue !== null && initialSessionStorageValue === maxNbOpenPerSession) {
		sessionStorage.setItem(
			storageKey,
			String(initialSessionStorageValue >= 1 ? initialSessionStorageValue - 1 : 0),
		);
	}
}

const POILIST_CANONICAL_LABEL = 'canonicalPoiListPage';

export const sessionPoiListCanonicalLink = {
	...sessionOrLocaleStorage('session', POILIST_CANONICAL_LABEL),
	consume() {
		if (!browser) return;
		const value = this.get?.();
		this.remove?.();
		return value;
	},
};
